<template>
  <div class="deduct_personal">
    <template-form
      title="ค่าลดหย่อนต่างๆ"
      description="ค่าลดหย่อนสำหรับบุคคลธรรมดาที่แสดงเป็นเพียง บางรายการเพื่อประกอบการคำนวณเท่านั้น คุณสามารถดูรายละเอียดรายการลดหย่อน"
    >
      <div slot="remark" class="remark">
        * คณะบุคคลและห้างหุ้นส่วนสามัญใช้สิทธิ์ลดหย่อน ได้แค่ค่าลดหย่อนส่วนตัว
        และบริจาคเท่านั้นนะ
      </div>
      <span slot="link" class="underline" @click="goToDetailDeduct">
        ได้ที่นี่<img class="crll-img" :src="EXTERNALICON" alt="externalicon" />
      </span>

      <div class="dpb-answer">
        <div class="dpba-caption">ส่วนตัว</div>
        <currency mode="readOnly" class="left" v-model="personalAllowance" />
      </div>

      <div class="dpb-answer">
        <div class="dpba-caption">ประกันสังคมต่อปี</div>
        <currency v-model="sso" v-on:change="setSso" />
      </div>
      <div class="dpb-answer">
        <div class="dpba-caption">
          ประกันชีวิตตนเอง <span>(สูงสุด ฿100,000)</span>
        </div>
        <currency v-model="lifeInsurance" v-on:change="setLifeInsurance" />
      </div>

      <div class="dpb-answer">
        <div class="dpba-caption">
          ประกันสุขภาพตนเอง <span>(สูงสุด ฿15,000)</span>
        </div>
        <currency v-model="healthInsurance" v-on:change="setHealthInsurance" />
      </div>

      <div class="dpb-answer">
        <div class="dpba-caption">บริจาคเพื่อการศึกษา/ โรงพยาบาล</div>
        <currency v-model="specialDonation" v-on:change="setSpecialDonation" />
      </div>

      <div class="dpb-answer">
        <div class="dpba-caption">บริจาคทั่วไป</div>
        <currency v-model="generalDonation" v-on:change="setGeneralDonation" />
      </div>

      <div class="dpb-footer">
        <back-button caption="ย้อนกลับ" />

        <chevron-right-link @clickLink="goNext" caption="ถัดไป" />
      </div>
    </template-form>

    <div class="e2-loading">
      <div class="il-active" />
    </div>
    <StateAnswer />
  </div>
</template>

<script>
import StateAnswer from "@/components/StateAnswer.vue";
import EXTERNALICON from "@/assets/icons/external.svg";

export default {
  name: "DeductPersonal",
  components: {
    StateAnswer,
  },
  data() {
    const specialDonation = this.$store.getters["taxInfo/getDeduct"]
      .specialDonation;
    const generalDonation = this.$store.getters["taxInfo/getDeduct"]
      .generalDonation;
    const sso = this.$store.getters["taxInfo/getDeduct"].sso;
    const lifeInsurance = this.$store.getters["taxInfo/getDeduct"]
      .lifeInsurance;
    const healthInsurance = this.$store.getters["taxInfo/getDeduct"]
      .healthInsurance;
    return {
      personalAllowance: 60000,
      sso,
      lifeInsurance,
      healthInsurance,
      specialDonation,
      generalDonation,
      EXTERNALICON,
    };
  },
  methods: {
    goToDetailDeduct() {
      window.open(
        "https://www.rd.go.th/publish/fileadmin/user_upload/SMEs/infographic/Pit_63_5-1.pdf",
        "_blank"
      );
    },
    goNext() {
      this.$router.push({ path: "/forms/tax_compare" });
    },
    setPersonalAllowance() {
      this.$store.dispatch("taxInfo/addDeductValue", {
        name: "personalAllowance",
        value: 60000,
      });
    },
    setSso(value) {
      this.$store.dispatch("taxInfo/addDeductValue", {
        name: "sso",
        value: value,
      });
    },
    setHealthInsurance(value) {
      this.$store.dispatch("taxInfo/addDeductValue", {
        name: "healthInsurance",
        value: value,
      });
    },
    setLifeInsurance(value) {
      this.$store.dispatch("taxInfo/addDeductValue", {
        name: "lifeInsurance",
        value: value,
      });
    },
    setSpecialDonation(value) {
      this.$store.dispatch("taxInfo/addDeductValue", {
        name: "specialDonation",
        value: value,
      });
    },
    setGeneralDonation(value) {
      this.$store.dispatch("taxInfo/addDeductValue", {
        name: "generalDonation",
        value: value,
      });
    },
  },
};
</script>

<style scoped>
.deduct_personal {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.underline {
  color: #29a9e2;
  text-decoration: underline;
  cursor: pointer;
}
.remark {
  font-size: 17px;
  color: #acb1bf;
  margin-top: 16px;
}
.dpb-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 16px;
  max-width: 352px;
  text-align: left;
}
.crll-img {
  margin-left: 5px;
  height: 16px;
}
.dpb-answer {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  width: 100%;
  max-width: 352px;
}
.dpba-caption {
  display: flex;
}
.dpba-caption > span {
  color: #acb1bf;
  margin-left: 6px;
}
.left {
  text-align: left !important;
}
.dpba-input {
  height: 24px;
  width: 320px;
  padding: 15px 16px;
  border-radius: 5px;
  border: 1px solid #acb1bf;
}
.dpba-fixed {
  border: 1px solid #d8d9e0;
  pointer-events: none;
  cursor: default;
}

.dpb-footer {
  margin-top: 24px;
  margin-bottom: 31px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 352px;
}
.dpb-footer .crl-link {
  justify-content: flex-end;
}

.e2-loading {
  width: 100%;
  height: 8px;
  background: #e6e8ec;
  position: relative;
}
.il-active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 100%;
  height: 100%;
  background: #008fc1;
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  .dpb-detail {
    max-width: 514px;
    text-align: center;
    white-space: nowrap;
    margin-bottom: 28px;
  }
}
</style>
